import React from "react";
import { ConfigMenuEnum } from "../../../../constants/AppConstants";
import { ManageInternalGrade } from "./CMSheetMenu/ManageInternalGrade/ManageInternalGrade";
import { StyledManageCMSheet } from "./ManageCMSheet.styled";
import { ManageFeedbacks } from "./CMSheetMenu/ManageFeedbacks/ManageFeedbacks";
import { ManageFinalInterview } from "./CMSheetMenu/ManageFinalInterview/ManageFinalInterview";
import { ManageSoftSkills } from "./CMSheetMenu/ManageSoftSkills/ManageSoftSkills";

export type ManageCMSheetProps = {
  selectedMenu: ConfigMenuEnum;
  configYear: number;
};

export const ManageCMSheet = ({
  selectedMenu,
  configYear,
}: ManageCMSheetProps) => {
  return (
    <StyledManageCMSheet>
      {selectedMenu === ConfigMenuEnum.INTERNAL_GRADE && (
        <ManageInternalGrade configYear={configYear} />
      )}
      {/* {selectedMenu === ConfigMenuEnum.GOALS && (
        <ManageGoals configYear={configYear} />
      )} */}
      {selectedMenu === ConfigMenuEnum.SOFT_SKILLS && (
        <ManageSoftSkills configYear={configYear} />
      )}
      {selectedMenu === ConfigMenuEnum.COLLABORATOR_COMMENT && (
        <ManageFeedbacks configYear={configYear} />
      )}
      {selectedMenu === ConfigMenuEnum.FINAL_INTERVIEW && (
        <ManageFinalInterview configYear={configYear} />
      )}
    </StyledManageCMSheet>
  );
};
